var render = function render(){var _vm=this,_c=_vm._self._c;return _c('template-editor-page-layout',{on:{"save":_vm.save,"save-new":_vm.saveNew}},[_c('keep-alive',[_c('email-editor',{ref:"editor",staticClass:"flex-grow-1",on:{"load":_vm.editorLoaded}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }